<template>
  <div
    class="chat-location chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    <MglMap
      v-if="message.location"
      class="message-map"
      :accessToken="accessToken"
      :scrollZoom="false"
      :dragPan="false"
      :mapStyle="mapStyle"
      :center="[message.location.lon, message.location.lat]"
      :zoom="15"
    >
      <MglMarker
        :coordinates="[message.location.lon, message.location.lat]"
        color="#404040"
      />
    </MglMap>
  </div>
</template>

<script>
import { MglMap, MglMarker } from 'vue-mapbox';
import MessageDate from '../MessageDate.vue';

export default {
  name: 'LocationItem',
  props: ['message'],
  components: {
    MessageDate,
    MglMap,
    MglMarker,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      mapStyle: process.env.VUE_APP_MAPBOX_STYLE,
    };
  },
};
</script>

<style lang="scss" scoped>
.message-map {
  height: 300px;
  border-radius: $default-radius;
  overflow: hidden;
}
</style>
